module.exports = __webpack_public_path__ + "static/media/9_r_mozaika_92.92_22.69.44f18a43.png";